import axios from 'axios';
import { router } from '@/router';

// import { goToPricing } from "@/helper/utils";

//Set default base URL
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

axios.interceptors.request.use(
  function (config) {
    if (!config.headers) {
      return;
    }

    const token = localStorage.getItem('token');

    config.headers.authorization = token
      ? `Bearer ${token}`
      : 'Bearer dssa78G8sbsjdDdndljvcd_bfbfcvshcb';

    config.headers['Content-Type'] = 'application/json';

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 403) {
      // goToPricing();
      router.push({ name: 'Pricing' });
    }

    return Promise.reject(error);
  }
);
